import { render, staticRenderFns } from "./MessageReactions.vue?vue&type=template&id=a14d10e6&scoped=true"
import script from "./MessageReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageReactions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageReactions.vue?vue&type=style&index=0&id=a14d10e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14d10e6",
  null
  
)

export default component.exports